import { useRef, useState } from 'react';
import { useModal } from '../../hooks/modalContext';
import { useProfileImage } from '../../hooks/profilePhoto';
import styles from './UploadPhoto.module.css';

import { ArrowUpFromLine, User, X } from 'lucide-react';
import { getPresignedUrl, updateUserProfile, uploadToS3 } from '../../../auth/_requests';
import { useAuth } from '../../../auth/Auth';
import { showToast } from '../../utils/showToast';
interface UploadPhotoProps {
  showClose?: boolean;
}
const UploadPhoto = ({ showClose = true }: UploadPhotoProps) => {
  const { setModal } = useModal();
  const { auth } = useAuth();
  const ImageInputRef = useRef<HTMLInputElement | null>(null);
  const { profileImageUrl, setProfileImageUrl, setPhotoUpdated } = useProfileImage();
  const [, setSelectedImage] = useState<File | null>(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const image = event.target.files ? event.target.files[0] : null;
    if (image) {
      setSelectedImage(image);
      setIsUploading(true);
      const { url, uploadUrl } = await getPresignedUrl(
        image.name,
        image.type,
        auth?.data.token,
        'tenant-profile'
      );
      await uploadToS3(image, uploadUrl);
      await updateUserProfile(auth?.data.token, { profilePicturePath: url });
      setProfileImageUrl(url);
      setPhotoUpdated((prev: boolean) => !prev);
      showToast({ message: 'Image Uploaded successfully', type: 'success' });
      setIsUploading(false);
      setTimeout(() => {
        setModal(null);
      }, 5000);
    }
  };

  return (
    <main className={styles.main}>
      {showClose && <X className={styles.crossIcon} size={24} onClick={() => setModal(null)} />}
      <section className={styles.section}>
        {profileImageUrl && !isUploading ? (
          <div
            className={styles.imageOuter}
            style={{
              backgroundImage: `url(${profileImageUrl})`,
            }}
          ></div>
        ) : (
          <div className={styles.nameImage}>
            <User stroke='#8A92AB' width={100} height={100} />
          </div>
        )}
        <button
          className={`submitBtn ${styles.btn}`}
          onClick={() => {
            if (ImageInputRef.current !== undefined) {
              ImageInputRef.current?.click();
            }
          }}
        >
          <span>Upload picture</span>
          <ArrowUpFromLine />
        </button>
        {isUploading && <p className={styles.uploadText}>Uploading...</p>}
      </section>
      <input
        name='profileImage'
        onChange={handleImageChange}
        multiple={false}
        ref={ImageInputRef}
        type='file'
        hidden
        accept='.jpg, .jpeg,.png, .svg'
      />
    </main>
  );
};
export default UploadPhoto;
